import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgIf } from '@angular/common';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { EnableEscCloseDirective } from '../../directives/enable-esc-close.directive';
import { UiButtonComponent } from '../ui-button/ui-button.component';
import { ConfirmDialogModel } from '../../models/confirm-dialog.model';

@Component({
  selector: 'ui-confirm-name-modal',
  standalone: true,
  imports: [NgIf, ReactiveFormsModule, TranslatePipe, UiButtonComponent],
  templateUrl: './ui-confirm-name-modal.component.html',
  styleUrl: './ui-confirm-name-modal.component.scss',
  hostDirectives: [EnableEscCloseDirective],
})
export class UiConfirmNameModalComponent {
  public confirmDialogSelection = ConfirmDialogModel.ConfirmResult;

  private readonly matchConfirmWork = (
    control: AbstractControl,
  ): ValidationErrors | null =>
    control.value === this.options.wordToConfirm
      ? null
      : { notMatching: true };

  public confirmWordControl!: FormControl;

  constructor(
    private dialogRef: MatDialogRef<
      UiConfirmNameModalComponent,
      ConfirmDialogModel.ConfirmResult
    >,
    @Inject(MAT_DIALOG_DATA) public options: ConfirmDialogModel.Options,
  ) {
    // `options` is assigned by Angular DI; avoid reading it in a field initializer
    // because field initializers run before the constructor executes.
    this.confirmWordControl = new FormControl('', [
      (control: AbstractControl): ValidationErrors | null =>
        Validators.required(control),
      (control: AbstractControl) => this.matchConfirmWork(control),
    ]);
  }

  public close(selection: ConfirmDialogModel.ConfirmResult): void {
    this.dialogRef.close(selection);
  }
}
